import {Component, OnInit, ViewChild} from '@angular/core';
import {FrontparentService, PageQuery, Proposal, SearchItem, SubContract, SubContractService} from '@tatynanny/api';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge} from 'rxjs';
import {startWith, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AlertService} from 'src/app/services/alert/alert.service';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.page.html',
  styleUrls: ['./contract.page.scss'],
})
export class ContractPage implements OnInit {
  segment: 'SENT' | 'ACTIVE' | 'ALL' = 'ALL';
  data: Proposal[] = [];
  displayedColumns: string[] = ["contractId", "creationDate", "parentContract.contractNanny.pricing.productType", "contractStatus", "totalPriceTTC", "action"];
  service: string = "";
  inputId: string = "";
  selectedDate: string = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  pageQuery: PageQuery = {
    fields: [
      {field: "contractId", value: this.inputId},
      {field: "parentContract.contractNanny.pricing.productType", value: this.service},
      {field: "contractStatus", value: this.segment},
      {field: "creationDate", value: this.selectedDate}
    ],
    sort: 'creationDate',
    direction: 'desc',
  }

  searchItems: SearchItem[] = [];

  constructor(
    private subContract: SubContractService,
    private router: Router,
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {

  }

  refresh(): void {
    this.searchItems = [
      {field: "contractId", value: this.inputId},
      {field: "parentContract.contractNanny.pricing.productType", value: this.service},
      {field: "contractStatus", value: this.segment},
      {field: "creationDate", value: this.selectedDate}
    ];
    this.pageQuery.fields = this.searchItems;
    this.subContract.search(this.pageQuery).subscribe((res: any) => {
      console.log('[contract] (searchContract)', res);
      this.data = res.content;
    });
  }


  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.pageQuery.sort = this.sort.active;
      this.pageQuery.direction = this.sort.direction;
      console.log(this.sort.active);
    });
    this.pageQuery.page = this.paginator.pageIndex;
    this.pageQuery.pageSize = this.paginator.pageSize;

    merge(this.sort.sortChange, this.paginator.page).pipe(startWith({}), switchMap(() => {
      return this.subContract.search(this.pageQuery);
    })).subscribe((data: any) => {
      console.log('[contract] (searchContract)', data);
      (this.data = data.content)
    });
  }

  onSegmentChange(event: any): void {
    console.log(event);
    this.segment = event;
    this.refresh();

  }

  onInputChange(event: any): void {
    console.log('[contract] (onInputChange)', event);
    this.inputId = event;
    this.refresh();
  }

  onServiceChange(event: any): void {
    console.log('[contract] (onServiceChange)', event);
    this.service = event.value;
    this.refresh();
  }

  onDateChange(event: any): void {
    console.log('[contract] (onDateChange)', event);
    this.selectedDate = event;
    this.refresh();
  }

  openContract(contract: SubContract): void {
    console.log('[contract] (openContract)', contract);

    if (contract.parentContract.contractNanny.pricing.productType === 'EXTRACURRICULAR') {
      if (!contract.candidate.autoEntreprise) {
        this.router.navigateByUrl(`/mon-espace/contrats/detail-contrat/${contract.id}/salarie`);
      } else {
        console.log('AUTO ENTREPRONNEUR');
        this.router.navigateByUrl(`/mon-espace/contrats/detail-contrat-ae/${contract.id}`);
      }
    }
    if (contract.parentContract.contractNanny.pricing.productType === 'MAID') {
      this.router.navigateByUrl(`/mon-espace/contrats/detail-contrat-maid/${contract.id}`)
    }
    if (contract.parentContract.contractNanny.pricing.productType === 'EDUCATIONAL_SUPPORT') {
      this.router.navigateByUrl(`/mon-espace/contrats/detail-contrat-edu/${contract.id}`);
      // this.alertService.temp('Le contrat est en cours de réalisation par l\'équipe TatyNanny');
    }
  }

}
